import { can } from './permissions.js'

export const naftaPosNavigationSections = [
  { labelKey: 'onlineIndicators', items: [
    { routeName: 'current-indicators', to: '/naftapos/online-indicators/current', labelKey: 'currentIndicators', permission: 'indicators.read' },
    { routeName: 'historical-indicators', to: '/naftapos/online-indicators/history', labelKey: 'historicalIndicators', permission: 'indicators.read' },
  ] },
  { labelKey: 'work', items: [
    { routeName: 'home', to: '/naftapos/reports', labelKey: 'reports', permission: 'reports.catalog.read' },
    { routeName: 'receipts', to: '/naftapos/receipts', labelKey: 'receipts', permission: 'receipts.read' },
  ] },
  { labelKey: 'configuration', items: [
    { routeName: 'admin-tank-capacities', to: '/naftapos/admin/tank-capacities', labelKey: 'tankCapacities', permission: 'tank_capacities.read' },
  ] },
  { labelKey: 'administration', items: [
    { routeName: 'admin-automation', to: '/naftapos/admin/automation', labelKey: 'automation', permission: 'automation.state.read' },
    { routeName: 'admin-monitoring', to: '/naftapos/admin/monitoring', labelKey: 'monitoring', permission: 'monitoring.read' },
  ] },
]

export const platformNavigationSections = [
  { labelKey: 'access', items: [
    { routeName: 'access-users', to: '/platform/users', labelKey: 'users', icon: 'users', permission: 'access.users.read' },
    { routeName: 'access-roles', to: '/platform/roles', labelKey: 'rolesAndPermissions', icon: 'roles', permission: 'access.roles.read' },
  ] },
  { labelKey: 'stationRegistry', items: [
    { routeName: 'platform-stations', to: '/platform/stations', labelKey: 'physicalStations', icon: 'stations', permission: 'stations.configuration.read' },
  ] },
  { labelKey: 'partnerApi', items: [
    { routeName: 'partner-api-clients', to: '/platform/partner-api-clients', labelKey: 'partnerApiClients', icon: 'api', permission: 'partner-api.clients.manage' },
  ] },
]

export const pts2NavigationSections = [
  { labelKey: 'pts2NavStatuses', items: [
    { routeName: 'pts2-overview', to: '/pts2/overview', labelKey: 'pts2CurrentStatus', icon: 'current', permission: 'pts2.application.use' },
  ] },
  { labelKey: 'pts2NavDevices', items: [
    { routeName: 'pts2-controllers', to: '/pts2/controllers', labelKey: 'pts2ControllersNav', icon: 'controllers', permission: 'pts2.application.use' },
    { routeName: 'pts2-diagnostics', to: '/pts2/diagnostics', labelKey: 'pts2DiagTitle', icon: 'document', permission: 'pts2.diagnostics.manage' },
    { routeName: 'pts2-alerts', to: '/pts2/alerts', labelKey: 'pts2Alerts', icon: 'alerts', permission: 'pts2.application.use' },
  ] },
  { labelKey: 'pts2NavGps', items: [
    { routeName: 'pts2-geolocation', labelKey: 'pts2Geolocation', icon: 'location', permission: 'pts2.application.use', disabled: true },
    { routeName: 'pts2-routes', labelKey: 'pts2Routes', icon: 'routes', permission: 'pts2.application.use', disabled: true },
    { routeName: 'pts2-waybills', labelKey: 'pts2Waybills', icon: 'document', permission: 'pts2.application.use', disabled: true },
  ] },
  { labelKey: 'pts2NavStorage', items: [
    { routeName: 'pts2-transactions', to: '/pts2/transactions', labelKey: 'pts2Transactions', icon: 'transactions', permission: 'pts2.application.use' },
    { routeName: 'pts2-measurements', to: '/pts2/tank-measurements', labelKey: 'pts2Measurements', icon: 'measurements', permission: 'pts2.application.use' },
    { routeName: 'pts2-deliveries', to: '/pts2/in-tank-deliveries', labelKey: 'pts2Deliveries', icon: 'deliveries', permission: 'pts2.application.use' },
  ] },
  { labelKey: 'pts2NavPricing', items: [
    { routeName: 'pts2-prices', labelKey: 'pts2NavPrices', icon: 'price', permission: 'pts2.application.use', disabled: true },
    { routeName: 'pts2-price-scheduler', labelKey: 'pts2PriceScheduler', icon: 'calendar', permission: 'pts2.application.use', disabled: true },
    { routeName: 'pts2-price-history', labelKey: 'pts2NavPriceHistory', icon: 'history', permission: 'pts2.application.use', disabled: true },
  ] },
  { labelKey: 'pts2NavReports', items: [
    { routeName: 'pts2-full-shift-report', labelKey: 'pts2FullShiftReport', icon: 'document', permission: 'pts2.application.use', disabled: true },
  ] },
  { labelKey: 'pts2NavSettings', items: [
    { routeName: 'pts2-color-mappings', to: '/pts2/color-mappings', labelKey: 'pts2ColorMappings', icon: 'colors', permission: 'pts2.application.use' },
  ] },
]

export const navigationSections = naftaPosNavigationSections

export function visibleNavigationSections(user, area = 'naftapos') {
  const sections = area === 'platform' ? platformNavigationSections
    : (area === 'pts2' ? pts2NavigationSections : naftaPosNavigationSections)
  return sections.map((section) => ({
    ...section,
    items: section.items.filter((item) => can(user, item.permission)),
  })).filter((section) => section.items.length)
}

export function firstAccessibleRouteFor(user) {
  const item = naftaPosNavigationSections.flatMap((section) => section.items)
    .find((candidate) => can(user, candidate.permission))
  return item?.routeName ?? platformNavigationSections.flatMap((section) => section.items)
    .find((candidate) => can(user, candidate.permission))?.routeName ?? 'no-access'
}
